import { SERVICE_API_ENDPOINT } from '../config/apiConfig';
import HttpClient from '../helpers/HttpClient';

// function to fetch category blog listings
class FormService {
  async getService(payload) {
    const response = await HttpClient.post(
      SERVICE_API_ENDPOINT.CREATE_SERVICE,
      payload
    );
    return response;
  }
}
export default new FormService();
